const CardToggle = {
    init: function () {
        $('.expandable-card').each(function () {
            const $card = $(this);
            const $expandButton = $card.find('.expand-button');
            const $collapseButton = $card.find('.collapse-button');

            $expandButton.on('click', function () {
                $card.addClass('expanded');
            });

            $collapseButton.on('click', function () {
                $card.removeClass('expanded');
            });
        });
    }
};

export { CardToggle };